import { render, staticRenderFns } from "./o-d-footer.vue?vue&type=template&id=7540a53a&"
import script from "./o-d-footer.vue?vue&type=script&lang=js&"
export * from "./o-d-footer.vue?vue&type=script&lang=js&"
import style0 from "./o-d-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports